import { useContext, useState } from "react";
import styles from "./Header.module.css";
import Context from "../../Context";
import { MenuT, SociaisT, MenuItemsT } from "../../interfaces";
import { uniqueId } from "lodash";
import { Link, useNavigate } from "react-router-dom";

import MenuIcon from "./menu.svg";

const Header = () => {
    const navigate = useNavigate();
    const { imagens, resumo } = useContext(Context);
    const [RMenu, setRMenu] = useState(false);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.logo}>
                    {imagens && imagens.logo ? <img onClick={() => navigate("/")} src={imagens.logo.large} alt="Logo" /> : <></>}
                    <div className={styles.social}>
                        {resumo?.sociais && resumo?.sociais.length > 0 ? resumo?.sociais.map((social: SociaisT) => {
                            return (
                                <a key={uniqueId("sociais_")} href={social.link} title={social.nome} rel="noopener noreferrer" target="_blank">
                                    <img src={social.light.large} alt={social.nome} />
                                </a>
                            );
                        })
                            : <></>
                        }
                    </div>
                </div>
                <button type="button" className={styles.hamburguer} onClick={() => setRMenu(true)}>
                    <img src={MenuIcon} alt="Menu" />
                </button>
                <div className={`${styles.overlay} ${RMenu ? styles.active : ""}`} onClick={() => setRMenu(false)}>
                    {resumo?.menus.filter((obj: MenuT) => obj.nome === "Header").map((menu: MenuT) => {
                        return (<div key={uniqueId("menu_wrapper_")} className={styles.menu}>
                            {menu.related.menu_items.map((item: MenuItemsT) => {
                                if (parseInt(item.externo) === 1) {
                                    return <a key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} href={item.link} title={item.nome} target={"_blank"} rel="noopener noreferrer">
                                        <span>{item.nome}</span>
                                    </a>
                                } else {
                                    return <Link key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} to={item.link} title={item.nome}>
                                        <span>{item.nome}</span>
                                    </Link>
                                }
                            })}
                        </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default Header;